import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// The app defines a custom NAMED font-size scale in `styles/globals.css`
// (`--text-micro` … `--text-heading`). tailwind-merge doesn't know these are
// font sizes, so by default it treats e.g. `text-body` as a text-COLOR utility
// and silently DROPS it whenever a real color class (`text-primary`,
// `text-foreground`, …) is merged in the same `cn()` call — the element then
// falls back to the root 16px instead of the intended 13px. Registering the
// scale in the `font-size` class group makes tailwind-merge resolve these to
// font-size (so size + color coexist, and two sizes still dedupe correctly).
const twMerge = extendTailwindMerge({
	extend: {
		classGroups: {
			"font-size": [
				"text-micro",
				"text-fine",
				"text-caption",
				"text-body",
				"text-label",
				"text-subtitle",
				"text-heading",
			],
		},
	},
});

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}
